<div class="header k-mb-4">
    <h5>{{ 'OrganizationTypes' | translate: {Default: "Organization Types"} }}</h5>
    <div>
        <button mat-flat-button setColor="primaryColour" color="primary" appPreventDoubleClick (throttledClick)="editOrCreateOrgType()">
            <mat-icon aria-hidden="false" class="material-icons-outlined" aria-label="add icon">add</mat-icon> 
            {{ 'AddOrganizationType' | translate: {Default: "Add Organization Type"} }}
        </button>
    </div>
</div>

<mat-dialog-content>
    <app-data-grid-comp
        [gridId]="gridId"
        hideActionButtons="true"
        [columns]="columns"
        [gridDataResult]="gridDataResult"
        [pageSize]="pageSize"
        [skip]="skip"
        [clearSelectedItems]="clearSelectedItems"
        [rowSelectionSettings]="{
            canSelectRows: true,
            selectableMode: 'multiple',
            selectRowBy: 'id'
        }"
        clickableRows="true"
        [isLoading]="isLoading"
        searchable="true"
        showRefreshButton="true"
        (emitRefreshEvent)="getOrganizationTypes()"
        [sortable]="{
            mode: 'multiple'
        }"
        [sortableColumns]="sortableColumns"
        (emitOpenDialogEvent)="editOrCreateOrgType($event)"
        (emitGridStateChangeEvent)="gridStateChange($event)"
        (emitDeleteEvent)="openConfirmDeleteDialog($event)"
    ></app-data-grid-comp>
</mat-dialog-content>

<mat-dialog-actions>
    <button mat-raised-button appPreventDoubleClick (throttledClick)="close()">Cancel</button>
</mat-dialog-actions>
